import React from 'react'
import { fileExt as fileExtConst, topicForLecturer, topicForStudent } from '../../../../../constants/constants'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../services/web/useWebService'
import * as synthesisReviewType from './synthesisReviewType'
import checkPermission from '../../../../../utilities/checkPermission'
import useLoading from '../../../../../control/loading/useLoading'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../i18n/useTranslate'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import authenStore from '../../../../../stores/authen/authenStore'

import { DialogType } from '../../../../../control/dialog/dialog'
import { requestWebServiceTypes } from '../../../../../services/web/types'
import { RoutePath } from '../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import {
    DocumentInfo,
    SynthesisReviewInfo,
    SynthesisReviewRemarkInfo,
} from '../../../../../services/web/types/responseWebServiceTypes'
import path from 'path'
import useProjectHook from '../../../shareLogic/useProjectHook'
import {
    SynthesisReviewProjectRequestType,
    UpdateFileStampRequestType,
} from '../../../../../services/web/types/requestWebServiceTypes'
import { TabSelectedType } from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useFolderAndTab from '../../useFolderAndTab'
import { FormApi } from 'final-form'
import _ from 'lodash'

const useSynthesisReview = (props: synthesisReviewType.UseSynthesisReviewType) => {
    const { callbackSaveComplete } = props
    const manageProjectStore = useManageProjectStore()
    const projectHook = useProjectHook()

    const projectData = manageProjectStore.projectData
    const loadingHook = useLoading()
    const translate = useTranslate()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const [initialValues, setInitialValues] = React.useState<any>({})
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const profileStore = authenStore()
    const { profile } = profileStore
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const history = useHistory()
    const [initialComment, setInitialComment] = React.useState<any>([])
    const [synthesisReviewInfoList, setSynthesisReviewInfo] = React.useState<SynthesisReviewInfo[]>([])
    const [isLoadedSynthesisReview, setIsLoadedSynthesisReview] = React.useState<boolean>(false)
    const [synthesisReviewRemarkInfoList, setSynthesisReviewRemarkInfo] = React.useState<SynthesisReviewRemarkInfo>()
    const [documentInfoList, setDocumentInfo] = React.useState<DocumentInfo[]>([])
    const [approveStatus, setApproveStatus] = React.useState<synthesisReviewType.ApproveType>()
    const [initialRichTextEditor, setInitialRichTextEditor] = React.useState<any>([])
    const [initialCommentRichTextEditor, setInitialCommentRichTextEditor] = React.useState<any>([])
    const [initialRichRemark, setInitialRichRemark] = React.useState<any>()
    const [isEditStampFile, setIsEditting] = React.useState(!isViewMode)

    const formValues = React.useRef<synthesisReviewType.TFormValue>()
    const tabAndFolderHook = useFolderAndTab()

    React.useEffect(() => {
        getSynthesisReviewData()
        getSynthesisData()
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null])

    React.useEffect(() => {
        if (Number(projectData?.stepID) > 8) {
            createInitialRichTextEditor()
        }
        createInitialData()
        createInitialComment()
        createInitialRichRemark()
    }, [isLoadedSynthesisReview])

    React.useEffect(() => {
        createInitialComment()
    }, [translate.languageStore.currentLanguage])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const handleDirtyChange = (props: any, formRef: FormApi<any, Partial<any>>) => {
        formValues.current = { ...props.values }
        let isDirty: boolean = false
        //** จัดformat initValue และ Form Value เพื่อเตรียมตัวนำไปใช้เปรียบเทียบค่า  **//
        const documentSelected = documentInfoList.filter((item) => item.isCheckAll === true)
        let newFormValue = { ...props.values }
        if (documentSelected.length > 0) {
            newFormValue.documentCertificate = {
                childSelected: _.flattenDeep(documentSelected.map((itm) => itm.fileInfo)),
                parentSelected: documentSelected,
            }
        }
        let initValue = { ...formRef.getState().initialValues }
        initValue.commentDirector = initValue.commentDirector?.map((data: any, idx: number) => ({
            ...data,
            consideration: initialRichTextEditor[idx],
            commentList: initialRichTextEditor[idx],
        }))
        initValue.remark = initialRichRemark

        //**********************************************************//
        const isEqual = _.isEqual(newFormValue, initValue) //ข้อมูลเท่ากัน

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        } else {
            isDirty = false
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        const parameter = getParameterForSave(formValues.current)
        if (parameter) {
            parameter.isDraft = true
            handleConfirmSave(parameter, tabIndex, newTabSelected, isFolder)
        }
    }

    const getParameterForSave = (val: synthesisReviewType.TFormValue) => {
        let paramForSave = null
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        let isDraft = false
        if (val.submitType === 'draft') {
            isDraft = true
        }
        let isApproveWithCommentFlow
        if (manageProjectStore?.projectData) {
            isApproveWithCommentFlow = projectHook.isFlowApproveWithComment(manageProjectStore?.projectData)
        }

        const isNotHaveStampFileList =
            val?.documentCertificate?.childSelected?.length === 0 &&
            val?.documentCertificate?.parentSelected?.length === 0

        if (isApproveWithCommentFlow) {
            const synthesisReviewProjectRequest: requestWebServiceTypes.SynthesisReviewApproveWithCommentType = {
                loginUserID: profile.userId,
                submittedID: submittedID,
                stampFileList: isNotHaveStampFileList ? null : val.documentCertificate,
                isDraft: isDraft,
            }
            paramForSave = synthesisReviewProjectRequest
        } else {
            const synthesisReviewProjectRequest: requestWebServiceTypes.SynthesisReviewProjectRequestType = {
                loginUserID: profile.userId,
                submittedID: submittedID,
                synthesisReviewInfo: val.commentDirector?.map((itm: any) => {
                    return {
                        commentaryTopicId: itm.id,
                        comment:
                            itm.consideration && itm.consideration.contentText ? itm.consideration.contentText : null,
                        comment_htmltag:
                            itm.consideration && itm.consideration.contentHtml ? itm.consideration.contentHtml : null,
                    }
                }),
                stampFileList: isNotHaveStampFileList ? null : val.documentCertificate,
                synthesisReviewRemarkInfo: {
                    remark: val.remark && val.remark.contentText ? val.remark.contentText : null,
                    remark_htmltag: val.remark && val.remark.contentHtml ? val.remark.contentHtml : null,
                },
                isDraft: isDraft,
            }
            paramForSave = synthesisReviewProjectRequest
        }
        return paramForSave
    }

    const handleSubmitForm = async (val: synthesisReviewType.TFormValue) => {
        const parameter = getParameterForSave(val)
        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    handleConfirmSave(parameter)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }

    const handleClickEditStampFile = async () => {
        setIsEditting(true)
    }

    const handleCancelEditStampFile = async () => {
        setIsEditting(false)
        dialogRef.current?.closeDialog()
    }

    const handleSaveEditStampFile = async () => {
        setIsEditting(false)
        dialogRef.current?.closeDialog()

        loadingHook.loadingOpen()
        const parameter = getParameterForSave(formValues.current) as UpdateFileStampRequestType
        let res = await callWebService.updateFileStamp(parameter)

        if (callbackSaveComplete) {
            if (res && res.status) {
                callbackSaveComplete(res.status, false)
            }
        }
        loadingHook.loadingClose()
    }

    const handleConfirmSave = async (
        paramForSave:
            | requestWebServiceTypes.SynthesisReviewProjectRequestType
            | requestWebServiceTypes.SynthesisReviewApproveWithCommentType,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        let isApproveWithCommentFlow
        if (manageProjectStore?.projectData) {
            // isEditAfterReview = projectHook.isEditAfterReview(manageProjectStore?.projectData)
            isApproveWithCommentFlow = projectHook.isFlowApproveWithComment(manageProjectStore?.projectData)
        }
        dialogRef.current?.closeDialog()

        const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
        loadingHook.loadingOpen()
        let res
        if (isApproveWithCommentFlow) {
            const param = { ...paramForSave } as SynthesisReviewProjectRequestType
            res = await callWebService.synthesisReviewApproveWithCommentProject(param)
        } else {
            const param = { ...paramForSave } as requestWebServiceTypes.SynthesisReviewProjectRequestType
            res = await callWebService.synthesisReviewProject(param)
        }

        if (!isFolder) {
            //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
            if (tabIndex && newTabSelected) {
                //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
                tabAndFolderHook.setTab(tabIndex, newTabSelected)
            } else {
                //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
                if (callbackSaveComplete) {
                    if (res && res.status) {
                        callbackSaveComplete(res.status, isDraft)
                    }
                }
            }
        }
        loadingHook.loadingClose()
    }

    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const getSynthesisData = async () => {
        if (projectData) {
            loadingHook.loadingOpen()
            const submittedID = projectData.submittedID
            const { result } = await callWebService.getSynthesisProjectByID(submittedID)
            loadingHook.loadingClose()

            if (result) {
                const approveStatus = {
                    id: result.approveStatusID,
                    nameTH: result.approveStatusName_th,
                    nameEN: result.approveStatusName_en,
                }
                setApproveStatus(approveStatus)
            }

            const commentList = result.synthesisInfo.map((item) => {
                let comment: { contentHtml: string | null; contentText: string | null } = {
                    contentHtml: '',
                    contentText: '',
                }
                comment.contentText = item.comment.contentText ?? null
                comment.contentHtml = item.comment.contentHtml ?? null
                return comment
            })
            setInitialCommentRichTextEditor(commentList)
            // if (projectData?.stepID === 8) {
            //     setInitialRichTextEditor(commentList)
            // }
        }
    }

    const getSynthesisReviewData = async () => {
        if (projectData) {
            setIsLoadedSynthesisReview(false)
            loadingHook.loadingOpen()
            const submittedID = projectData.submittedID
            const data = await callWebService.getSynthesisReview(submittedID)
            loadingHook.loadingClose()
            if (data.status === 1) {
                let documentInfo = [...data.result.documentInfo]
                documentInfo.forEach((itm) => {
                    const topicID = itm.topicID
                    let isCheckAll: boolean | null = null
                    itm.fileInfo.forEach((file) => {
                        file.topicID = topicID
                        if (path.extname(`${file.filename}`) === fileExtConst.pdf) {
                            if (file.isStamp && isCheckAll !== false) {
                                isCheckAll = true
                            } else {
                                isCheckAll = false
                            }
                        }
                    })
                    itm.isCheckAll = isCheckAll
                })
                //  BUG IS STAMP ออกมาเป็น false หมดเลย
                // setApproveStatus(data?.result?.approveStatusName_th)
                // setDocumentInfo(data.result.documentInfo)

                const commentList = data.result.synthesisReviewInfo.map((item) => {
                    let comment: { contentHtml: string | null; contentText: string | null } = {
                        contentHtml: '',
                        contentText: '',
                    }
                    comment.contentText = item.synthesisReviewComment ?? null
                    comment.contentHtml = item.synthesisReviewCommentHtmlTag ?? null
                    return comment
                })
                setInitialRichTextEditor(commentList)

                filterTopicUpload(documentInfo)
                // setDocumentInfo(documentInfo)
                setSynthesisReviewInfo(data.result.synthesisReviewInfo)
                setSynthesisReviewRemarkInfo(data.result.synthesisReviewRemarkInfo)
                setIsLoadedSynthesisReview(true)
            }
        }
    }

    const filterTopicUpload = (documentTopic: DocumentInfo[]) => {
        let docTopic: DocumentInfo[] = []
        const researcherTypeID = projectData?.researcherTypeInfo.value
        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item: any) => {
                        return item.topicID !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, topicNo: index + 1 }
                })
            }
            setDocumentInfo(docTopic)
        }
    }

    const createInitialComment = () => {
        const commentInit = synthesisReviewInfoList?.map((itm: any) => {
            return {
                topic:
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? itm.topicName_th
                        : itm.topicName_en,
                id: itm.topicID,
                no: itm.topicNo,
                commentList: {
                    contextHtml: itm.synthesisReviewCommentHtmlTag ?? '',
                    contentText: itm.synthesisReviewComment ?? '',
                },
            }
        })
        setInitialComment(commentInit)
    }

    const createInitialData = () => {
        const { childSelectedList, parentSelectedList } = getInitialChildSelected()

        const initialData = {
            documentCertificate: {
                childSelected: childSelectedList,
                parentSelected: parentSelectedList,
            },
            commentRemarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList.synthesisRemark
                    ? synthesisReviewRemarkInfoList.synthesisRemark
                    : '-',
            remarkList:
                synthesisReviewRemarkInfoList && synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    : '-',
        }

        setInitialValues(initialData)
    }

    const getInitialChildSelected = () => {
        let childSelectedList: any = []
        let parentSelectedList: any = []
        documentInfoList.forEach((documentItm) => {
            if (documentItm.fileInfo.length > 0) {
                documentItm.fileInfo.forEach((file) => {
                    if (file.isStamp) {
                        childSelectedList.push(file)
                    }
                })
            }
            if (documentItm.isCheckAll) {
                parentSelectedList.push(documentItm)
            }
        })

        return { parentSelectedList, childSelectedList }
    }

    const setDocInfoList = () => {
        let initFileLang: synthesisReviewType.SelectedListWithLangType[] = []
        documentInfoList.forEach((dataItm: any) => {
            dataItm.fileInfo.forEach((file: any) => {
                initFileLang.push({
                    fileID: file?.fileID,
                    language: file?.language ? file?.language : 'th',
                })
            })
        })

        return initFileLang
    }

    const createInitialRichTextEditor = () => {
        const initialData = synthesisReviewInfoList.map((itm) => {
            return {
                contentHtml: itm.synthesisReviewCommentHtmlTag
                    ? itm.synthesisReviewCommentHtmlTag
                    : itm.synthesisComment,
                contentText: itm.synthesisReviewComment,
            }
        })
        setInitialRichTextEditor(initialData)
    }

    const createInitialRichRemark = () => {
        const initialData = {
            contentHtml: isViewMode
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html ?? ''
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html ?? ''
                    : '-'
                : synthesisReviewRemarkInfoList?.synthesisReviewRemark_html ?? ''
                ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html ?? ''
                : synthesisReviewRemarkInfoList?.synthesisRemark ?? '',
            contentText: synthesisReviewRemarkInfoList?.synthesisReviewRemark ?? '',
        }

        setInitialRichRemark(initialData)
    }

    return {
        approveStatus,
        initialValues,
        projectData,
        initialComment,
        documentInfoList,
        initialRichTextEditor,
        initialCommentRichTextEditor,
        initialRichRemark,
        isViewMode,
        isFlowApproveWithComment: projectData ? projectHook.isFlowApproveWithComment(projectData) : false,
        configDialog,
        isShowUpdateDate,
        onRefDialog,
        onSubmitForm: handleSubmitForm,
        handleDirtyChange: handleDirtyChange,
        onClickCancel: handleClickCancel,
        isEditStampFile,
        clickEditStampFile: handleClickEditStampFile,
        cancelEditStampFile: handleCancelEditStampFile,
        saveEditStampFile: handleSaveEditStampFile,
    }
}

export default useSynthesisReview
